export default {
  feedback: {
    token_required: 'Haz clic en la casilla para verificar que eres humano',
    frequent_requests:
      'Comprueba tu SMS. Ya hemos enviado el código al número indicado. Si no lo recibes, verifica el número o inténtalo de nuevo en 10 minutos.',
  },
};
